








































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import GlobalOverlayMethods from '@/mixins/GlobalOverlayMethods.vue';
import cloneDeep from 'lodash/cloneDeep';
import TicketHelper from '@/mixins/TicketHelper.vue';
import { resetScroll, setScroll } from '@/plugins/save-position';

@Component({
    computed: {
        ...mapGetters({
            allUserTickets: 'UserTickets/getAllUserTickets',
        }),
    },
})
export default class StaffTicketsList extends Mixins(
    DateMethods,
    TicketHelper,
    GlobalOverlayMethods,
) {
    @Prop() public containerId: string;

    constructor() {
        super();
    }

    get activeTab(): string {
        return this.$store.getters['UserTickets/getActiveStaffTicketsType'];
    }

    get filteredTickets() {
        const priority      = this.$store.getters['UserTickets/getSelectedTicketPriority'];
        const searchQuery   = this.$store.getters['UserTickets/getTicketSearchQuery'];
        let filteredTickets = cloneDeep(this.$store.getters['UserTickets/getAllUserTicketsOrdered']);

        if (searchQuery.trim() !== '') {
            filteredTickets = filteredTickets.filter((ticket: any) => {
                return ticket.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    ticket.message.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    ticket.id === Number(searchQuery);
            });
        }

        if (priority !== -1) {
            filteredTickets = filteredTickets.filter((ticket: any) => {
                return ticket.priority === priority;
            });
        }

        return filteredTickets;
    }

    @Watch('activeTab')
    public activeTabChanged() {
        resetScroll('tickets', this.containerId, 'staff');
    }

    public goToTicketDetails(ticket: any) {
        this.$store.commit(Mutations.SET_USER_CURRENT_TICKET, ticket);
        this.$router.push({name: 'tickets-details', params: {ticketId: ticket.id}});
    }

    public openMessages(ticket: any) {
        if (!ticket.conversation) {
            return;
        }

        this.$store.commit(Mutations.SET_USER_CURRENT_TICKET, ticket);
        this.$router.push({ name: 'tickets-chat', params: { ticketId: ticket.id }});
    }

    public openSortingOptions() {
        this.openGlobalOverlay({
            pageComponent: 'FilterStaffTicketsList',
            dialogClasses: 'hoc-global-dialog-slider',
        });
    }

    public mounted() {
        setScroll(this.containerId, 'getStaffAppPagePosition');
    }
}
